<template>
  <div id="app" class="container-fluid">

    <router-view></router-view>

  </div>
</template>

<script>

export default {
  name: 'app',
}

</script>
<style src="./assets/flatly/bootstrap.min.css"></style>
